module.exports = __webpack_public_path__ + "img/icon-email.26e172a5.svg";